import React from "react";
import cn from "classnames";
import styles from "./Head.module.sass";

const Head = ({ className, contactRequest }) => {
  // Fonction pour formater la date
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  // Fonction pour formater le type
  const formatType = (type) => {
    const types = {
      'assistance': 'Assistance',
      'commercial': 'Commercial',
      'technique': 'Technique',
      'autre': 'Autre'
    };
    return types[type] || type;
  };

  // Fonction pour formater le statut
  const formatStatus = (status) => {
    const statuses = {
      'pending': 'En attente',
      'processed': 'Traité',
      'rejected': 'Rejeté'
    };
    return statuses[status] || status;
  };

  // Fonction pour obtenir la classe de statut
  const getStatusClass = (status) => {
    switch (status) {
      case 'pending':
        return 'status-yellow';
      case 'processed':
        return 'status-green';
      case 'rejected':
        return 'status-red';
      default:
        return 'status-gray';
    }
  };

  return (
    <div className={cn(styles.head, className)}>
      <div className={styles.user}>
        <div className={styles.avatar}>
          <img src="/images/content/user_logo.png" alt="Contact" />
        </div>
        <div className={styles.details}>
          <div className={styles.man}>
            {contactRequest ? contactRequest.nom : 'Aucune sélection'}
          </div>
          <div className={styles.login}>
            {contactRequest ? contactRequest.societe : ''}
          </div>
        </div>
      </div>
      {contactRequest && (
        <div className={styles.statusInfo}>
          <div className={styles.statusGroup}>
            <div className={styles.statusLabel}>Statut</div>
            <div className={cn(
              styles.statusBadge,
              'status-type',
              getStatusClass(contactRequest.status)
            )}>
              {formatStatus(contactRequest.status)}
            </div>
          </div>
          <div className={styles.statusGroup}>
            <div className={styles.statusLabel}>Type</div>
            <div className={cn(
              styles.statusBadge,
              'status-type',
              'status-blue-dark'
            )}>
              {formatType(contactRequest.type)}
            </div>
          </div>
          <div className={styles.statusGroup}>
            <div className={styles.statusLabel}>Date</div>
            <div className={cn(
              styles.statusBadge,
              'status-type',
              'status-green-dark'
            )}>
              {formatDate(contactRequest.created)}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Head;
